import {
  time,
  Entity,
  Scheduler,
  coreEngine,
} from "@dinahmoe/dmafjs-core";

class PropertySet extends Entity {
  namespace = "control:property:set";

  init(node) {
    node.complete = new Scheduler(this, this.onComplete.bind(this, node));
  }

  execute(node, config, event) {
    // change in v20, untested
    node.props = config;

    node.complete.clear();
    const delay = node.props.delay ?? 0;
    const timeSum = event.time + delay;
    const startTime = timeSum < time.current ? time.current : timeSum;

    node.propertyUid = node.props.propertyUid;
    node.value = node.props.value;

    this.log("setting", node.propertyUid, "to", node.value);
    if (delay !== 0) {
      node.complete.schedule(startTime, startTime);
      return;
    }

    const firstDot = node.props.propertyUid.indexOf(".");
    const targetUid = node.props.propertyUid.slice(0, firstDot);
    const propertyName = node.props.propertyUid.slice(firstDot + 1);

    coreEngine.update({
      uid: targetUid,
      key: propertyName,
      value: node.props.value,
    });
  }

  onComplete(node, endTime) {
    const firstDot = node.propertyUid.indexOf(".");
    const targetUid = node.propertyUid.slice(0, firstDot);
    const propertyName = node.propertyUid.slice(firstDot + 1);

    coreEngine.update({
      uid: targetUid,
      key: propertyName,
      value: node.value,
    });

    const eventName = `${node.uid}:complete`;
    this.dispatch(eventName, endTime);
  }
}

const propertySet = new PropertySet();
export { propertySet, PropertySet };
